import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";
import { getRefreshToken } from "src-next/shared/api/utils/tokenStorage";

export async function RefreshToken() {
  const url = `${endpoints.token_api}`;
  const refreshToken = getRefreshToken() ?? "";
  const data = `grant_type=refresh_token&refresh_token=${refreshToken}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getBasicToken(),
    "Content-Type": "application/x-www-form-urlencoded",
  };
  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`RefreshToken error: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
  if (response) return response;
}
